// BLL/Routes.jsx
import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { useEffect, useState} from 'react';
import Home from '../Pages/Home';
import Portfolio from '../Pages/Portfolio';
import Contact from '../Pages/Contact';
import PageLayout from '../Layouts/PageLayout'; // This is where FloatingHeader is likely rendered
import About from '../Pages/About';
import PlayGround from '../Pages/PlayGround';
import Releases from '../Pages/Releases';
import Collaborators from '../Pages/Collaborators';
import SomethingElse from '../Pages/SomethingElse';
import NotFound from '../Pages/NotFound';
import PortfolioArchive from '../Pages/PortfolioArchive';
import EternalSeptember from '../Pages/EternalSeptember';

export default function AppRoutes() {
  const location = useLocation();
  const [scrollReady, setScrollReady] = useState(false);
  
  // 1. LIFTED STATE: State to control the sub-component within Portfolio
  // Initialize to "projects" so hitting the "Work" link defaults to it.
  const [portfolioPage, setPortfolioPage] = useState("projects"); 

  // Ensure scroll happens only once, after exit
  useEffect(() => {
    if (scrollReady) {
      window.scrollTo(0, 0);
      setScrollReady(false); // reset for next transition
    }
  }, [scrollReady]);

  return (
    <AnimatePresence 
      mode="wait" 
      initial={false}
      onExitComplete={() => setScrollReady(true)}
    >
      <Routes location={location} key={location.pathname}>
        {/*
          2. Pass the state and setter to PageLayout. 
          The PageLayout must now accept these props and pass them down 
          to the FloatingHeader component it renders.
        */}
        <Route 
          path="/" 
          element={
            <PageLayout 
              currentPage={portfolioPage} 
              setCurrentPage={setPortfolioPage}>
              <Home />
            </PageLayout>
          } 
        />
        <Route 
          path="/about" 
          element={
            <PageLayout 
              currentPage={portfolioPage} 
              setCurrentPage={setPortfolioPage}>
              <About />
            </PageLayout>
          } 
        />
        {/* 3. Pass the state and setter to the Portfolio component itself.
        */}
        <Route 
          path="/portfolio" 
          element={
            <PageLayout 
              currentPage={portfolioPage} 
              setCurrentPage={setPortfolioPage}>
              <Portfolio 
                currentPage={portfolioPage} 
                setCurrentPage={setPortfolioPage} 
              />
            </PageLayout>
          } 
        />
        
        {/* 4. Apply to other routes if they use PageLayout, or omit if PageLayout handles the props gracefully */}
        <Route 
          path="/contact" 
          element={
            <PageLayout 
              currentPage={portfolioPage} 
              setCurrentPage={setPortfolioPage}>
              <Contact />
            </PageLayout>
          } 
        />
        {/* ... (Continue applying to other routes using PageLayout) */}

        <Route path="/playground" element={<PageLayout currentPage={portfolioPage} setCurrentPage={setPortfolioPage}><PlayGround /></PageLayout>} />
        <Route path="/releases" element={<PageLayout currentPage={portfolioPage} setCurrentPage={setPortfolioPage}><Releases /></PageLayout>} />
        <Route path="/collaborators" element={<PageLayout currentPage={portfolioPage} setCurrentPage={setPortfolioPage}><Collaborators /></PageLayout>} />
        <Route path="/something-else" element={<PageLayout currentPage={portfolioPage} setCurrentPage={setPortfolioPage}><SomethingElse></SomethingElse></PageLayout>} />
        <Route path="/archive" element={<PageLayout currentPage={portfolioPage} setCurrentPage={setPortfolioPage}><PortfolioArchive></PortfolioArchive></PageLayout>}></Route>
        <Route path="/eternal-september" element={<PageLayout currentPage={portfolioPage} setCurrentPage={setPortfolioPage}><EternalSeptember></EternalSeptember></PageLayout>}></Route>
        <Route path="*" element={<PageLayout currentPage={portfolioPage} setCurrentPage={setPortfolioPage}><NotFound></NotFound></PageLayout>}></Route>
      </Routes>
    </AnimatePresence>
  );
}